

export enum EnumSituacaoProcessamento {
    INVALIDA = 0,
    RECEBIDO = 1,
    NOTIFICADO = 2,
    PROCESSANDO = 3,
    FINALIZADO = 4,
    CANCELADO = 5
}